exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modalHeader___4i3Qx {\n  padding: 0 40px;\n}\n.modalTitle___1ikdZ {\n  text-align: center;\n  padding: 30px 0;\n  border-bottom: 1px solid #d9d9d9;\n}\n.modalBody___k7ixA {\n  padding: 30px 40px;\n}\n.suggestionItem___20746 {\n  border-bottom: 1px solid #d9d9d9;\n}\n.suggestionBtn___1IS3O {\n  align-items: center;\n  display: flex;\n  padding: 10px;\n  justify-content: space-between;\n  width: 100%;\n  border: none;\n  background: none;\n  text-align: left;\n}\n.suggestionBtn___1IS3O:hover {\n  background: #e8f4f6;\n}\n.suggestionSelect___bY0Hf {\n  white-space: nowrap;\n}\n", ""]);

// exports
exports.locals = {
	"modalHeader": "modalHeader___4i3Qx",
	"modalTitle": "modalTitle___1ikdZ",
	"modalBody": "modalBody___k7ixA",
	"suggestionItem": "suggestionItem___20746",
	"suggestionBtn": "suggestionBtn___1IS3O",
	"suggestionSelect": "suggestionSelect___bY0Hf"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/pages/Events/SuggestionModal/SuggestionModal.module.less
// module id = 2573
// module chunks = 71